
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { formatDisplayDate } from '@/util/formatters'
import { JcdcLabeledText } from '@/components/jcdc/index'

export default Vue.extend({
  components: {
    JcdcLabeledText,
  },
  computed: {
    ...mapState('evaluations', ['goals']),
    ...mapGetters('evaluations', ['goalsList']),
  },
  methods: {
    formatDisplayDate,
    formatGoalDetails(item) {
      let modified
      if (item.lastModUser) {
        modified = {
          Modified: {
            By: item.lastModUser,
            Date: this.formatDisplayDate(item.lastModDt),
          },
        }
      }
      return {
        Type: item.goalType,
        Category: item.category,
        Area: item.area,
        Progress: item.progress,
        Esp: item.esp,
        Added: {
          By: item.addUser,
          Date: this.formatDisplayDate(item.addDt),
        },
        ...modified,
      }
    },
  },
})
